module.exports = __webpack_public_path__ + "naghmeh-social-icon--youtube.svg?e956cade790c615506a9df59508490e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--youtube.svg
// module id = 213
// module chunks = 0